export default function formatTotalizersTotal(value: string | number) {
  if (!value) {
    return '0'
  }

  const numericValue =
    typeof value === 'number'
      ? value
      : Number(String(value ?? '').replace(/\D/g, '')) / 100

  return numericValue.toFixed(2)
}
